module.exports = __webpack_public_path__ + "static/media/Mario.cff08e75.jpg";